import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchClients,
  fetchClientByID,
  filterClients,
  selectClients,
  fetchMoreClients,
  getFullList,
} from "./clientsSlice";

import Grid from "@material-ui/core/Grid";
import Client from "./Client";
import ClientsList from "./ClientsList";
import Error from "../../common/Error";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function ClientsContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");

  const dispatch = useDispatch();
  const classes = useStyles();

  const [clientNames, setClientNames] = useState([]);
  const [clientIDs, setClientIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");
  const [ready, setReady] = useState(false);

  const {
    clients,
    error,
    loading,
    clientsList,
    client,
    lastQuery,
    clientsAmount,
  } = useSelector(selectClients);

  const [statusNames, setStatusNames] = useState(["Active"]);
  const [statusIDs, setStatusIDs] = useState([1]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const handleClientsChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedClient = clientsList.filter(
      (client) => client.name === event.target.value
    );
    selectedClient && idsArr.push(selectedClient[0].id);
    // });

    setClientNames(event.target.value);
    setClientIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchClients({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > clientsList.length ? rowsPerPage : clientsList.length,
        query: searchQuery,
        targetLength: clientsAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        clientsList.length < clientsAmount &&
        clientsList.length < expectedLen
      ) {
        dispatch(
          fetchMoreClients({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (clientsList.length == clientsAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "emailAddress":
        property = "email_address";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchClients({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchClients({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setClientNames([]);
    setClientIDs([]);
    setStatusNames([]);
    setStatusIDs([]);

    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchClients({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchClientByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const headCells = [
    {
      id: "name",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Name",
      long: true,
      sortable: true,
    },

    {
      id: "description",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Description",
      long: true,
    },
    {
      id: "emailAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Email",
      long: false,
      sortable: true,
    },
    {
      id: "phoneNumber",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Phone",
      long: false,
    },
    {
      id: "mobileNumber",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Mobile",
      long: false,
    },
    {
      id: "websiteURL",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "PS Website",
      long: false,
    },

    {
      id: "invPaymentMode",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Payment Mode",
      long: false,
    },
    {
      id: "statusID",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Status",
      long: false,
      sortable: true,
    },
  ];
  const [rowList, setRowList] = useState([...headCells]);

  const selectNames = ["status"];

  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <ClientsList
        clients={clients}
        handleClientsChange={handleClientsChange}
        clientNames={clientNames}
        clientIDs={clientIDs}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        filterNames={clientNames}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={clientsAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
